import React, { Component } from 'react';
import { Table, Layout, Popconfirm, InputNumber, Affix, Button } from 'antd';
import Head from '../../components/Head';
import ICP from '../../components/ICP';
import Foote from '../../components/Footer';
import Iconz from '../../components/Iconz';
import '../../css/mall.css';

const { Content } = Layout;

const list = [];
for (let i = 0; i < 46; i++) {
    list.push({
        key: i,
        img: 'http://www.17sucai.com/preview/1/2017-08-21/jQueryGwc/images/2.png',
        name: '商品' + i,
        property: '商品参数',
        price: i + 1,
        count: 2
    })
}

class MShoppingCar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            goodList: list,
            selectedRowKeys: [],
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource(this.props.match.params.teamno);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 删除
     * @param i
     */
    handleDelete = (i) => {
        const { goodList } = this.state,
            good = goodList[i];
        goodList.splice(i, 1);
        this.setState({ goodList, selectedRowKeys: [] });
        // console.log(good);
    }

    /**
     * 删除选中选项
     * @param i
     */
    handleSelDelete = () => {
        // const {goodList} = this.state;
        // goodList.splice(i, 1);
        // this.setState({goodList, selectedRowKeys: []});
        // console.log(good);
    }

    /**
     * 表格选择变化
     * @param selectedRowKeys
     */
    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    }

    /**
     * 数量变化
     * @param i
     */
    handleCountChage = (value, i) => {
        const { goodList } = this.state;
        goodList[i].count = value;
        this.setState({ goodList });
    }

    /**
     * 计算总金额
     * @returns {number}
     */
    calcAmount = () => {
        const { selectedRowKeys, goodList } = this.state;
        let total_amount = 0;
        for (let i in selectedRowKeys) {
            const good = goodList[parseInt(selectedRowKeys[i])];
            if (good) {
                total_amount += (parseInt(good.count) * parseFloat(good.price));
            }
        }
        return total_amount.toFixed(2);
    }

    render() {
        const { goodList, selectedRowKeys, data_loading } = this.state,
            columns = [
                {
                    title: '商品信息',
                    dataIndex: 'info',
                    key: 'info',
                    width: '30%',
                    render(text, record) {
                        return (
                            <div className="good-info">
                                <div className="good-img"><a href="javascript:;"><img src={record.img} alt="" /></a>
                                </div>
                                <div className="good-name"><a href="javascript:;">{record.name}</a>
                                </div>
                            </div>
                        );
                    }
                },
                {
                    title: '商品参数',
                    dataIndex: 'property',
                    key: 'property',
                    width: '15%'
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                    key: 'price',
                    width: '10%'
                },
                {
                    title: '数量',
                    dataIndex: 'count',
                    key: 'count',
                    width: '15%',
                    render: (text, record, index) => {
                        return (
                            <InputNumber min={1} max={999} defaultValue={text}
                                onChange={(value) => this.handleCountChage(value, index)} />
                        );
                    }
                },
                {
                    title: '金额',
                    dataIndex: 'amount',
                    key: 'amount',
                    width: '15%',
                    render(text, record) {
                        return (parseInt(record.count) * parseFloat(record.price)).toFixed(2);
                    }
                },
                {
                    title: '操作',
                    dataIndex: '',
                    key: 'cz',
                    width: '10%',
                    render: (text, record, index) => {
                        return (
                            <Popconfirm placement="bottom" title="确定删除该商品吗？" onConfirm={() => this.handleDelete(index)}
                                okText="确定"
                                cancelText="取消">
                                <a href="javascript:;">移除商品</a>
                            </Popconfirm>
                        )
                    }
                },
            ],
            rowSelection = {
                selectedRowKeys,
                onChange: this.onSelectChange,
            },
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: data_loading ? '正在加载中...' : '暂无商品',
            };
        return (
            <Layout className='shopping-car'>
                <Head notLogin={(
                    <div className="frame-head-logo">
                        <Iconz type="icon-logo_" size={48} />
                    </div>
                )} background="#3F89C1" height={78} history={this.props.history} />
                <Content id="car-content">
                    <div className="car-content">
                        <Table rowSelection={rowSelection}
                            title={() => <h2 style={{ color: '#666', margin: 0 }}>购物车</h2>}
                            loading={data_loading} columns={columns} locale={locale}
                            dataSource={goodList} pagination={false} />

                        <Affix offsetBottom={0} target={() => document.getElementById('car-content')}>
                            <div className="clear-affix">
                                <div className="del-sel">
                                    {
                                        selectedRowKeys.length > 0 ? (
                                            <Popconfirm placement="top" title="确定删除选中的商品吗？"
                                                onConfirm={() => this.handleSelDelete}
                                                okText="确定"
                                                cancelText="取消">
                                                <a href="javascript:;">删除选中的商品</a>
                                            </Popconfirm>
                                        ) : ''
                                    }
                                </div>
                                <div className="clear-action">
                                    <div className="sel-count">已选商品 <strong> {selectedRowKeys.length} </strong> 件</div>
                                    <div className="sel-amount">共计： <strong>￥{this.calcAmount()}</strong></div>
                                    <Button className="clear-btn" type="primary">结算</Button>
                                </div>
                            </div>
                        </Affix>
                    </div>
                    <Foote />
                    <ICP bg="#434343" />
                </Content>
            </Layout>
        );
    }
}

export default MShoppingCar;



// WEBPACK FOOTER //
// ./src/routes/mall/MShoppingCar.jsx